
import { ProductInfo } from '../../../mocks/products';

export default function ProductFeatures({ product }: { product: ProductInfo }) {
  return (
    <section className="py-24 bg-[#f5f3ef]">
      <div className="max-w-6xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-16">
          <span
            className="inline-block text-xs font-bold px-4 py-1.5 rounded-full text-white mb-6"
            style={{ backgroundColor: product.color }}
          >
            {product.name} の特長
          </span>
          <h2 className="text-3xl font-bold text-[#1a2332] leading-tight" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            {product.label}を引き出す、6つの設計思想
          </h2>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {product.features.map((feature, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-7 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
            >
              <div
                className="w-14 h-14 rounded-xl flex items-center justify-center mb-5 transition-colors group-hover:scale-110 duration-300"
                style={{ backgroundColor: `${product.color}12` }}
              >
                <i className={`${feature.icon} text-2xl`} style={{ color: product.color }}></i>
              </div>
              <h3 className="text-base font-bold text-[#1a2332] mb-3">{feature.title}</h3>
              <p className="text-sm text-[#4a4a4a] leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>

        {/* Case Study */}
        <div className="mt-16 rounded-2xl overflow-hidden shadow-lg" style={{ backgroundColor: product.color }}>
          <div className="p-10 text-white">
            <div className="flex items-center gap-2 mb-6">
              <i className="ri-double-quotes-l text-3xl text-white/40"></i>
              <span className="text-xs font-bold px-3 py-1 rounded-full bg-white/20">導入事例</span>
            </div>
            <p className="text-base leading-relaxed mb-6 max-w-3xl">
              {product.caseStudy.quote}
            </p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                <i className="ri-user-line text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-bold">{product.caseStudy.company}</div>
                <div className="text-xs text-white/70">{product.caseStudy.role}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
